import { ref, set, get, push, update } from "firebase/database";
import { rtdb } from "./firebase";
import { normalizeOrderStatus } from "../utils/orderStatus";

/**
 * Cria um novo pedido no Firebase
 */
export async function createOrder(orderData) {
    try {
        const orderRef = push(ref(rtdb, "orders"));
        const orderId = orderRef.key;

        const order = {
            id: orderId,
            ...orderData,
            status: normalizeOrderStatus(orderData.status),
            createdAt: Date.now(),
            updatedAt: Date.now(),
        };

        await set(orderRef, order);

        // cria evento inicial (timeline)
        try {
            const evRef = push(ref(rtdb, `orders/${orderId}/events`));
            await set(evRef, {
                type: "created",
                status: order.status,
                at: Date.now(),
            });
        } catch (e) {
            // não bloqueia pedido
            console.warn("Não foi possível salvar evento inicial:", e);
        }

        // Salvar também no histórico do usuário
        if (orderData.userId) {
            const userOrderRef = push(ref(rtdb, `users/client/${orderData.userId}/orders`));
            await set(userOrderRef, {
                orderId,
                createdAt: Date.now(),
            });
        }

        return { ok: true, orderId };
    } catch (error) {
        console.error("Erro ao criar pedido:", error);
        return { ok: false, error };
    }
}

/**
 * Busca todos os pedidos
 */
export async function getAllOrders() {
    try {
        const snapshot = await get(ref(rtdb, "orders"));
        if (!snapshot.exists()) {
            return [];
        }

        const data = snapshot.val();
        return Object.keys(data).map((id) => ({
            id,
            ...data[id],
        }));
    } catch (error) {
        console.error("Erro ao buscar pedidos:", error);
        return [];
    }
}

/**
 * Busca pedidos de um usuário específico
 */
export async function getUserOrders(userId) {
    try {
        const snapshot = await get(ref(rtdb, "orders"));
        if (!snapshot.exists()) {
            return [];
        }

        const data = snapshot.val();
        return Object.keys(data)
            .map((id) => ({
                id,
                ...data[id],
            }))
            .filter((order) => order.userId === userId)
            .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
    } catch (error) {
        console.error("Erro ao buscar pedidos do usuário:", error);
        return [];
    }
}

/**
 * Busca um pedido específico por ID
 */
export async function getOrderById(orderId) {
    try {
        const snapshot = await get(ref(rtdb, `orders/${orderId}`));
        if (!snapshot.exists()) {
            return null;
        }

        return {
            id: orderId,
            ...snapshot.val(),
        };
    } catch (error) {
        console.error("Erro ao buscar pedido:", error);
        return null;
    }
}

/**
 * Atualiza o status de um pedido
 */
export async function updateOrderStatus(orderId, status) {
    try {
        const normalized = normalizeOrderStatus(status);
        await update(ref(rtdb, `orders/${orderId}`), {
            status: normalized,
            updatedAt: Date.now(),
        });

        // evento de status
        const evRef = push(ref(rtdb, `orders/${orderId}/events`));
        await set(evRef, {
            type: "status",
            to: normalized,
            at: Date.now(),
        });
        return { ok: true };
    } catch (error) {
        console.error("Erro ao atualizar status do pedido:", error);
        return { ok: false, error };
    }
}
